import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactionSearchCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .5,
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.36719 6.89746C4.12455 6.89746 3.11719 7.90482 3.11719 9.14746V18.8975C3.11719 20.1401 4.12455 21.1475 5.36719 21.1475H18.8672C20.1098 21.1475 21.1172 20.1401 21.1172 18.8975V9.14746C21.1172 7.90482 20.1098 6.89746 18.8672 6.89746H5.36719ZM19.6172 8.39746H4.61719V19.6475H19.6172V8.39746Z",
				fill: "#000000"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 3.11719,
				y: 10.6475,
				width: 18,
				height: 1.5,
				fill: "#000000"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 6.86719,
				y: 4.64746,
				width: 1.5,
				height: 3,
				fill: "#000000"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 15.8672,
				y: 4.64746,
				width: 1.5,
				height: 3,
				fill: "#000000"
			})
		]
	})
});
export default SvgTransactionSearchCalendar;
